import _ from 'lodash'

import { AREA_INDUSTRY_USER_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: AREA_INDUSTRY_USER_MNG,
  params: null,
  formatData(data) {
    data.extensionList = []
    data.extensionLabelList.forEach(element => {
      data.extensionList.push(element.id)
    })

    data.postsalesLeaderList = []
    data.postsalesLeaderLabelList.forEach(element => {
      data.postsalesLeaderList.push(element.id)
    })

    data.postsalesList = []
    data.postsalesLabelList.forEach(element => {
      data.postsalesList.push(element.id)
    })

    return data
  },
  view: {
    title: '创建区域&部门行业人员',
    labelPosition: 'right',
    labelWidth: '125px',
    width: '750px',
    content: [
      {
        $id: 'area',
        $type: 'select',
        label: 'pocMng.projectArea',
        $el: {
          clearable: true
        },
        $options: 'global/enum/area',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.label,
              label: item.label
            }
          })
          return value ? value : ''
        },
        rules: [{ notEmpty: { message: 'pocMng.projectAreaEmpty' } }]
      },
      {
        $id: 'industryList',
        $type: 'select',
        label: 'pocMng.industry',
        $el: {
          clearable: true,
          multiple: true
        },
        $options: 'projectInfo/industry/list',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.id,
              label: item.industryName
            }
          })
          if (!value) {
            return []
          }
          return Array.isArray(value) ? value : value.split(',')
        },
        rules: [{ notEmpty: { message: 'pocMng.industryEmpty' } }]
      },
      {
        $id: 'postsalesLeaderLabelList',
        $type: 'sky-relation-option',
        label: 'pocMng.postsalesLeaderIds',
        $el: { disabled: false, multiple: true },
        actions: {
          nativeOn: {
            click: 'UmRelationUserList'
          }
        },
        rules: [{ notEmpty: { message: 'pocMng.postsalesLeaderEmpty' } }]
      },
      {
        $id: 'extensionLabelList',
        $type: 'sky-relation-option',
        label: 'pocMng.extensionIds',
        $el: { disabled: false, multiple: true },
        actions: {
          nativeOn: {
            click: 'UmRelationUserList'
          }
        },
        rules: [{ notEmpty: { message: 'pocMng.extensionEmpty' } }]
      },
      {
        $id: 'postsalesLabelList',
        $type: 'sky-relation-option',
        label: 'pocMng.postsales',
        $el: { disabled: false, multiple: true },
        actions: {
          nativeOn: {
            click: 'UmRelationUserList'
          }
        }
      }
    ]
  }
}
